// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"298":"982bd0b7615cb8aa","506":"4700e45046a20fd7"}[chunkId] + ".js";
};